import React, { Component } from 'react'
import { connect } from 'react-redux'
import { Link } from 'react-router'
import { get } from 'lodash'

import classes from '../ProductItem.scss'
import { formatMoney } from 'helpers/utilities'
import { orderActions } from 'redux/actionCreators'

const mapStateToProps = (state, { product }) => {
  const _userClass = get(state, 'user.me.userClass') || 0
  const _priceField = ['retail', 'wholesale1', 'wholesale2', 'wholesale3', 'wholesale4'][_userClass]
  return {
    amount: get(state, ['order', 'cartProductMap', `${product.productCode}-0`, 'amount']),
    outOfStock: get(product, 'outOfStock') || 0,
    userPrice: get(product, _priceField) || 0
  }
}

const mapDispatchToProps = (dispatch, { product }) => ({
  openProductModal: (amount) =>
    dispatch({
      type: 'PRODUCT_MODAL_OPEN',
      productKey: `${product.productCode}-0`,
      amount
    }),
  onAddToCart: (payload) => {
    return dispatch(orderActions.attemptAddToCart({
      ...payload,
      productCode: product.productCode
    }))
  }
})

@connect(mapStateToProps, mapDispatchToProps)
class ProductItem extends Component {
  constructor (props) {
    super(props)
    this.state = { amount: props.amount || 1 }
  }

  componentDidMount () {
    window.objectFitImages()
    const images = document.getElementsByTagName('img')
    Object.keys(images).forEach(key => images[key].addEventListener('contextmenu', () => false))
  }

  componentWillReceiveProps (nextProps) {
    if (this.props.amount !== nextProps.amount) {
      this.setState({ amount: nextProps.amount })
    }
  }

  _onAddToCart = () => this.props.onAddToCart({
    amount: this.state.amount,
    unitId: '0',
    price: this.props.userPrice
  })

  _onWishlist = (exists) => {
    const { productCode } = this.props.product || {}
    if (exists) {
      this.props.onRemoveFromWishlist(productCode)
    } else {
      this.props.onAddToWishlist(productCode)
    }
  }

  render () {
    const { product, userPrice, openProductModal } = this.props
    return (
      <div ref='productItem' className={classes.productItem} id={product.productCode}>
        <div className='desktop'>
          <Link to={`/products/${product.productCode}`}>
            <div className={classes.thumbnailWrapper}>
              <img role='presentation' className={classes.thumbnail} src={product.imagePath} />
              <div className={classes.watermarkWrapper}>
                <img className={classes.watermark} src='/images/watermark.png' alt='watermark' width='60' height='20' />
              </div>
            </div>
          </Link>
          <div className={`${classes.btnHeart} ${product.userId && classes.added}`} onClick={() => this._onWishlist(Boolean(product.userId))}>
            <img width='24' height='20' src='/images/icon-heart.png' alt='heart' />
          </div>
        </div>
        <div className='mobile'>
          <div className={classes.thumbnailWrapper} onClick={() => openProductModal(this.state.amount)}>
            <img role='presentation' className={classes.thumbnail} src={product.imagePath} />
            <div className={classes.watermarkWrapper}>
              <img className={classes.watermark} src='/images/watermark.png' alt='watermark' width='60' height='20' />
            </div>
          </div>
        </div>
        {Boolean(!product.outOfStock) && (
          <div className={classes.buttons}>
            <div className={classes.box} onClick={() => this.setState({ amount: this.state.amount ? (this.state.amount - 1) : 0 })}>-</div>
            <div className={`${classes.box} ${(this.props.amount > 0) && classes.active}`}>{this.state.amount}</div>
            <div className={classes.box} onClick={() => this.setState({ amount: Math.min(this.state.amount + 1, product.stockAmount) })}>+</div>
          </div>
        )}
        {!product.outOfStock ? (
          <div className={classes.btnCart} onClick={this._onAddToCart}>
            <img src='/images/icon-cart-white.png' alt='icon-cart' width='16' height='15' />
            <span>ใส่ตะกร้า</span>
          </div>
        ) : (
          <div className={`strike-through ${classes.outOfStock}`}>
            สินค้าหมดชั่วคราว
          </div>
        )}
        <div className={`desktop ${classes.container}`}>
          <Link to={`/products/${product.productCode}`}>
            <div className={classes.name}>{product.productName}</div>
            <div className={classes.price}><strong>{formatMoney(userPrice)} บาท</strong></div>
            <div className={classes.stockAmount}>คลัง: {formatMoney(product.stockAmount).slice(0, -3)} {product.unit}</div>
          </Link>
        </div>
        <div className='mobile' onClick={() => openProductModal(this.state.amount)}>
          <div className={classes.name}>{product.productName}</div>
          <div className={classes.price}><strong>{formatMoney(userPrice)} บาท</strong></div>
          <div className={classes.stockAmount}>คลัง: {formatMoney(product.stockAmount).slice(0, -3)} {product.unit}</div>
        </div>
      </div>
    )
  }
}

export default ProductItem



/** WEBPACK FOOTER **
 ** ./src/components/products/ProductItem.js
 **/